export function isLazyLoaded (index, images, slideIndex, indicesOfLoadedImages) {
    const lastIndex = slideIndex === 0 ? images.length - 1 : slideIndex - 1;
    const nextIndex = slideIndex + 1;

    const indices = [lastIndex, slideIndex, nextIndex];

    return !indicesOfLoadedImages.includes(index) && !indices.includes(index);
}

export function imageChangeNeeded (newImage, oldImage) {
    return newImage.inherited || oldImage.inherited || !sourceImageHasSameSource(newImage, oldImage);
}

export function getBestImageIndex(item) {
    let bestImageIndex = -1;
    for (let i = 0; i < item.images.length; i++) {
        const image = item.images[i];
        if (image.inherited) {
            continue;
        }
        if (image.type === "LEGER") {
            bestImageIndex = i;
            break;
        }
        if (bestImageIndex === -1) {
            bestImageIndex = i;
        }
    }
    return bestImageIndex;
}

export function sourceImageHasSameSource(image1, image2) {
    const src1 = image1.detail.sources[0].srcSet.src;
    const src2 = image2.detail.sources[0].srcSet.src;

    return src1 === src2;
}
